import { Injectable } from '@angular/core';
import { Preferences } from '@capacitor/preferences';

@Injectable({ providedIn: 'root' })
export class LocalStorageService {
  constructor() {}

  async set(key: string, data: any) {
    try {
      const serializedData = JSON.stringify(data);
      await Preferences.set({ key, value: serializedData });
    } catch (error) {
      console.error('Error saving to local storage:', error);
    }
  }

  async get<T = any>(key: string): Promise<T | null> {
    try {
      const result = await Preferences.get({ key });
      if (result && result.value) {
        return JSON.parse(result.value) as T;
      }
      return null;
    } catch (error) {
      console.error('Error retrieving from local storage:', error);
      return null;
    }
  }

  async remove(key: string) {
    try {
      await Preferences.remove({ key });
    } catch (error) {
      console.error('Error removing from local storage:', error);
    }
  }
}
